/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type CartShippingTooltip_item$ref = any;
export type CartShippingTooltip_item = {
    readonly vertical: VerticalType | null;
    readonly " $refType": CartShippingTooltip_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartShippingTooltip_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "vertical",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'b6bc16eec0e5b74a13b97fe86d9cb877';
export default node;
